import { JetView } from 'webix-jet';
import { countries } from 'config/config';
import { profile } from 'config/config';
import { devConfig, accountingAccounts, providersSMS, providersEmail, providerPaymentWithdrawal } from 'config/config';

/**
 * Class representing the FilterAgentListView.
 * Extends JetView to create a view for filtering agent settings.
 */
export default class FilterAgentListView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const screen = this.app.config.size;
        var partnerCountry;

        // Event listener for partner settings filter
        this.on(this.app, 'partnerSettings:filter', (filterdata) => {
            partnerCountry = filterdata; // Store partner country data
        });

        // General information section
        const left_general = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'CompanyName',
                    label: "<div class='tittle'>" + _('Nombre Compañía') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Nombre Compañía'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
            ],
        };

        const center_left_general = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Address',
                    label: "<div class='tittle'>" + _('Dirección') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Dirección'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
            ],
        };

        const iconalert = {
            rows: [
                {
                    view: 'icon',
                    icon: 'mdi mdi-menu',
                    click: () => this.app.callEvent('menu:toggle'), // Toggle menu on click
                },
            ],
        };

        const center_right_general = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Phone',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Teléfono') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Teléfono'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
            ],
        };

        const right_general = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Email',
                    label: "<span class='icon-mail'></span>" + _('Email'),
                    labelPosition: 'top',
                    placeholder: _('Email'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
            ],
        };

        const upper_section_general = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left_general, center_left_general, center_right_general, right_general],
                },
            ],
        };

        // Accounting section
        const left_accounting = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    labelPosition: 'top',
                    label: "<div class='tittle'>" + _('Plan cuentas Apuestas Tickets Tiendas') + '</div>',
                    name: 'AccountingAccountsBetsTicketsStores',
                    options: accountingAccounts, // Options for accounting accounts
                },
            ],
        };

        const center_left_accounting = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    labelPosition: 'top',
                    label: "<div class='tittle'>" + _('Plan cuentas Premios Tickets Tiendas') + '</div>',
                    name: 'AccountingAccountsAwardsTicketsStores',
                    options: accountingAccounts, // Options for accounting accounts
                },
            ],
        };

        const center_right_accounting = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    labelPosition: 'top',
                    label: "<div class='tittle'>" + _('Plan cuentas Pagos notas de retiro') + '</div>',
                    name: 'AccountingAccountsPaymentsWithdrawal',
                    options: accountingAccounts, // Options for accounting accounts
                },
            ],
        };

        const right_accounting = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    labelPosition: 'top',
                    label: "<div class='tittle'>" + _('Plan de cuentas Recargas') + '</div>',
                    name: 'AccountingAccountsRecharge',
                    options: accountingAccounts, // Options for accounting accounts
                },
            ],
        };

        const upper_section_accounting = {
            id: 'a6',
            rows: [
                {
                    responsive: 'a6',
                    margin: 10,
                    cols: [left_accounting, center_left_accounting, center_right_accounting, right_accounting],
                },
            ],
        };

        // Registration section
        const left_register = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'LimitDepositDayDefault',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Limite depósito día por defecto') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el límite de depósito diario por defecto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Limite depósito día por defecto'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
            ],
        };

        const center_left_register = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'LimitDepositWeekDefault',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Limite depósito semana por defecto') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el límite de depósito semanal por defecto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Limite depósito semana por defecto'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
            ],
        };

        const center_right_register = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'LimitDepositMonthDefault',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Limite depósito mes por defecto') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el límite de depósito mensual por defecto') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Limite depósito mes por defecto'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
            ],
        };

        const right_register = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Usuario automáticamente activado') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique si el usuario quedara automáticamente activado después del registro') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith3',
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
            ],
        };

        // Provider section
        const left_provider = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    labelPosition: 'top',
                    label: "<div class='tittle'>" + _('Proveedor de SMS') + '</div>',
                    name: 'ProviderSMS',
                    options: providersSMS, // Options for SMS providers
                },
            ],
        };

        const center_left_provider = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    labelPosition: 'top',
                    label: "<div class='tittle'>" + _('Proveedor de Email') + '</div>',
                    name: 'ProviderEmail',
                    options: providersEmail, // Options for email providers
                },
            ],
        };

        const center_right_provider = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    labelPosition: 'top',
                    label: "<div class='tittle'>" + _('Proveedor pagos de retiros') + '</div>',
                    name: 'ProviderPaymentWithdrawal',
                    options: providerPaymentWithdrawal, // Options for payment withdrawal providers
                },
            ],
        };

        const right_provider = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        const upper_section_register = {
            id: 'a6',
            rows: [
                {
                    responsive: 'a6',
                    margin: 10,
                    cols: [left_register, center_left_register, center_right_register, right_register],
                },
            ],
        };

        const upper_section_provider = {
            id: 'a6',
            rows: [
                {
                    responsive: 'a6',
                    margin: 10,
                    cols: [left_provider, center_left_provider, center_right_provider, right_provider],
                },
            ],
        };

        // Security section
        const left_Security = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'UserPasswordExpireDays',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Días de expiración de la contraseña') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Días de expiración de la contraseña'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'richselect',
                    name: 'UserPasswordRegularExpression',
                    label:
                        "<label class='tittle'>" +
                        _('Regular Expresión contraseña usuario') +
                        '</label>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Expresión regular que valide una contraseña. ') +
                        '<br>' +
                        _('Ej: Que tenga entre 4 y 16 caracteres.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [],
                },
            ],
        };

        const center_left_Security = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'UserTempPasswordExpireDays',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Días de expiración contraseña temporal') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Días de expiración de la contraseña temporal') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Días de expiración de la contraseña temporal'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'UserWrongLoginAttempts',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Máximo intentos inicio sesión') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el número máximo de intentos para iniciar sesión') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Máximo intentos inicio sesión'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
            ],
        };

        const center_right_Security = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'UserPasswordMinLength',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Mínima longitud de la contraseña') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Mínima longitud de la contraseña'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
            ],
        };

        const right_Security = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'DaysNotifyBeforePasswordExpire',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Días antes de notificación de expiración') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Cuantos días antes de que expire la contraseña, se le notificara el cambio') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Días antes de notificación de expiración'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
            ],
        };

        const upper_section_Security = {
            id: 'a2',
            rows: [
                {
                    responsive: 'a2',
                    margin: 10,
                    cols: [left_Security, center_left_Security, center_right_Security, right_Security],
                },
            ],
        };

        // Client withdrawal section
        const left_client_withdrawal = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'MaxRequestsPerDay',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Máximo solicitudes por día') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Máximo solicitudes por día'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'MinPercentageWagered',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Porcentaje mínimo apostado/depositado') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el porcentaje mínimo apostado sobre lo depositado.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Porcentaje mínimo apostado sobre lo depositado'),
                    invalidMessage: _('Porcentaje Invalido'), // Invalid percentage message
                },
            ],
        };

        const center_left_client_withdrawal = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'RequestMinAmountWithdraw',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Mínimo monto en solicitud de retiro') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Mínimo monto en solicitud de retiro'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'RequestMinAmountWithdrawBetShop',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Mínimo retiros punto') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Mínimo monto en solicitud de retiro por punto de venta') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Mínimo retiros punto'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
            ],
        };

        const center_right_client_withdrawal = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'RequestMaxAmountWithdraw',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Máximo monto en solicitud de retiro') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Máximo monto en solicitud de retiro'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Requiere registro activo para retirar?') +
                        "</div><div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique si el usuario necesita tener el registro activado para poder retirar') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith6',
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
            ],
        };

        const right_client_withdrawal = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'MaxActiveRequests',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Máxima cantidad de solicitudes activas') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Máxima cantidad de solicitudes activas'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Requiere verificación de cuenta para retirar?') +
                        "</div><div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique si el usuario necesita verificar cuenta para poder retirar') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith7',
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
            ],
        };

        const upper_section_client_withdrawal = {
            id: 'a3',
            rows: [
                {
                    responsive: 'a3',
                    margin: 10,
                    cols: [
                        left_client_withdrawal,
                        center_left_client_withdrawal,
                        center_right_client_withdrawal,
                        right_client_withdrawal,
                    ],
                },
            ],
        };

        // Client deposit section
        const left_client_deposit = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'RequestMinAmount',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Mínimo monto de solicitud de deposito') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Mínimo monto de solicitud de deposito'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
            ],
        };

        const center_left_client_deposit = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'RequestMaxAmount',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Máximo monto de solicitud de deposito') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Máximo monto de solicitud de deposito'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
            ],
        };

        const center_right_client_deposit = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Requiere registro activo para depositar?') +
                        "</div><div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique si el usuario necesita tener el registro activado para poder depositar') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith4',
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
            ],
        };

        const right_client_deposit = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'label',
                    label:
                        "<div class='tittle'>" +
                        _('Requiere verificación de cuenta para depositar?') +
                        "</div><div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique si el usuario necesita verificar cuenta para poder depositar') +
                        '</span></div>',
                },
                {
                    css: 'centrar',
                    id: 'StateSwith5',
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'),
                    offLabel: _('Inactivo'),
                },
            ],
        };

        // General settings section
        const left_setings_general = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'TaxWithdrawBalanceDeposit',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Impuesto Retiro Saldo Deposito') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto Retiro Saldo Deposito'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'TaxWithdrawBalanceAwardFrom',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Impuesto Retiro Saldo Premios a partir de') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Impuesto por Retiro Saldo Premios a partir de un valor.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto Retiro Saldo Premios a partir de'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'richselect',
                    name: 'ApproveBankAccounts',
                    localId: 'State:combo',
                    label: "<div class='tittle'>" + _('Aprobar cuentas bancarias?') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'A', value: _('Activo') },
                        { id: 'I', value: _('Inactivo') },
                    ],
                },
                {
                    view: 'text',
                    name: 'PenaltyWithdrawalBalanceWithdrawal',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Porcentaje Penalidad Retiro Saldo Retiros') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el porcentaje de la penalidad por retiro a saldo de retiros.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Porcentaje Penalidad Retiro Saldo Retiros'),
                    invalidMessage: _('Porcentaje Invalido'), // Invalid percentage message
                },
                {
                    view: 'text',
                    name: 'DaysAlertUpdateData',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Días para alerta de actualización de datos') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Días para alerta de actualización de datos del usuario.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Días para alerta de actualización de datos'),
                },
            ],
        };

        const center_left_setings_general = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'TaxWithdrawBalanceAward',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Impuesto Retiro Saldo Premios') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto Retiro Saldo Premios'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'TaxRegulatorFrom',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Impuesto al ente regulador a partir de') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto al ente regulador a partir de'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'richselect',
                    name: 'ApproveChangesInformation',
                    localId: 'State:combo',
                    label:
                        "<label class='tittle'>" +
                        _('Aprobar cambios de información personal?') +
                        '</label>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Aprobar los cambios de información personal hechos por el usuario?') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'A', value: _('Activo') },
                        { id: 'I', value: _('Inactivo') },
                    ],
                },
                {
                    view: 'text',
                    name: 'MinimumWithdrawalBalanceWithdrawalsPenalty',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Mínimo Retiro de Saldo Retiros para Penalizar') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el monto mínimo de retiro de saldo retiros para penalizar.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Mínimo Retiro de Saldo Retiros para Penalizar'),
                    invalidMessage: _('Porcentaje Invalido'), // Invalid percentage message
                },
                {
                    view: 'text',
                    name: 'DaysAlertChangePassword',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Días para alerta de cambio de contraseña') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Días para alerta de cambio de contraseña') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Días para alerta de cambio de contraseña'),
                },
                {
                    view: 'richselect',
                    name: 'TypeCommissionSettlements',
                    label:
                        "<label class='tittle'>" +
                        _('Tipo de liquidaciones comisiones') +
                        '</label>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el tipo de liquidaciones para las comisiones, sea por caja o por cierre.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: 0,
                    options: [
                        { id: '0', value: _('Cierre Pagada') },
                        { id: '1', value: _('Cierre') },
                        { id: '2', value: _('Caja') },
                    ],
                },
                {
                    view: 'richselect',
                    name: 'TypeCommissionBetshop',
                    label:
                        "<label class='tittle'>" +
                        _('Tipo de comisión puntos de venta') +
                        '</label>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el tipo de comisión para los puntos de venta.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: 0,
                    options: [
                        { id: '0', value: _('Apuestas Pagadas') },
                        { id: '1', value: _('Apuestas Cerras') },
                    ],
                },
            ],
        };

        const center_right_setings_general = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'TaxRegulator',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Impuesto al ente regulador') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto al ente regulador'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'TaxPrizeBetShop',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Impuesto premios por punto de venta físico') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Impuesto a los premios reclamados por punto de venta físico') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto premios por punto de venta físico'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'MaxAccountsBank',
                    type: 'number',
                    label: "<div class='tittle'>" + _('Máximo cuentas bancarias') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Máximo cuentas bancarias'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'PenaltyWithdrawalBalanceRecharge',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Porcentaje Penalidad Retiro Saldo Recargas') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el porcentaje de la penalidad por retiro a saldo de recargas.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Porcentaje Penalidad Retiro Saldo Recargas'),
                    invalidMessage: _('Porcentaje Invalido'), // Invalid percentage message
                },
                {
                    view: 'text',
                    name: 'SessionInativityLength',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Inactividad de sesión en minutos') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Establezca el tiempo de inactividad en minutos para el cierre de sesión.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Inactividad de sesión en minutos'),
                },
                {
                    view: 'text',
                    name: 'SessionLength',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Duración de la sesión en minutos') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Establezca la duración de la sesión de juego en minutos.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Duración de la sesión en minutos'),
                },
                {
                    view: 'text',
                    name: 'URLFundCasino',
                    label:
                        "<div class='tittle'>" +
                        _('URL fondo casino') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Establezca la URL de la imagen para fondo de casino.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('URL fondo casino'),
                },
            ],
        };

        const right_setings_general = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'TaxWithdrawBalanceDepositFrom',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Impuesto Retiro Saldo Deposito a partir de') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Impuesto por Retiro Saldo Deposito a partir de un valor') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto Retiro Saldo Deposito a partir de'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'text',
                    name: 'TaxBetPayPrize',
                    type: 'number',
                    label:
                        _('Impuesto sobre apuesta al pagar premio') +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Impuesto sobre el monto de la apuesta al momento de pagar el premio') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Impuesto sobre apuesta al pagar premio'),
                    invalidMessage: _('Campo Requerido'), // Required field message
                },
                {
                    view: 'richselect',
                    name: 'ActivateRegisterUser',
                    localId: 'State:combo',
                    label: "<div class='tittle'>" + _('Requiere registro activo para iniciar sesión?') + '</div>',
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'A', value: _('Activo') },
                        { id: 'I', value: _('Inactivo') },
                    ],
                },
                {
                    view: 'text',
                    name: 'MinimumWithdrawalRefillsPenalty',
                    type: 'number',
                    label:
                        "<div class='tittle'>" +
                        _('Mínimo Retiro de Recargas para Penalizar') +
                        '</div>' +
                        "<div id='info' class='icon-exclamation-circle info'><span class='div-to-display'>" +
                        _('Especifique el monto mínimo de retiro de saldo recargas para penalizar.') +
                        '</span></div>',
                    labelPosition: 'top',
                    placeholder: _('Mínimo Retiro de Recargas para Penalizar'),
                    invalidMessage: _('Porcentaje Invalido'), // Invalid percentage message
                },
                {
                    view: 'form',
                    margin: 10,
                    minWidth: 200,
                    css: 'secutity',
                    id: 'contigencia',
                    rows: [
                        { view: 'label', label: _('Liquidaciones generadas') },
                        {
                            css: 'centrar',
                            id: 'StateSwith2',
                            view: 'switch',
                            labelWidth: 55,
                            onLabel: _('Automáticas'),
                            offLabel: _('Manuales'),
                        },
                        { view: 'label', label: _('Contigencia Total') },
                        {
                            css: 'centrar',
                            id: 'StateSwith',
                            view: 'switch',
                            labelWidth: 55,
                            onLabel: _('Activo'),
                            offLabel: _('Inactivo'),
                        },
                    ],
                },
            ],
        };

        const upper_section_client_deposit = {
            id: 'a4',
            rows: [
                {
                    responsive: 'a4',
                    margin: 10,
                    cols: [
                        left_client_deposit,
                        center_left_client_deposit,
                        center_right_client_deposit,
                        right_client_deposit,
                    ],
                },
            ],
        };

        const upper_section_setings_general = {
            id: 'a5',
            rows: [
                {
                    responsive: 'a5',
                    margin: 10,
                    cols: [
                        left_setings_general,
                        center_left_setings_general,
                        center_right_setings_general,
                        right_setings_general,
                    ],
                },
            ],
        };

        // Accordion section for grouping settings
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('General'),
                            body: {
                                padding: 10,
                                rows: [upper_section_general],
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            paddingY: 10,
                            header: _('Seguridad'),
                            body: {
                                padding: 10,
                                rows: [upper_section_Security],
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            paddingY: 10,
                            header: _('Solicitud de retiro de clientes'),
                            body: {
                                padding: 10,
                                rows: [upper_section_client_withdrawal],
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            paddingY: 10,
                            header: _('Solicitud de depósito de clientes'),
                            body: {
                                padding: 10,
                                rows: [upper_section_client_deposit],
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Ajustes Generales'),
                            body: {
                                padding: 10,
                                rows: [upper_section_setings_general],
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Contabilidad'),
                            body: {
                                padding: 10,
                                rows: [upper_section_accounting],
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Registro'),
                            body: {
                                padding: 10,
                                rows: [upper_section_register],
                            },
                        },
                    ],
                },
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Proveedores internos'),
                            body: {
                                padding: 10,
                                rows: [upper_section_register],
                            },
                        },
                    ],
                },
            ],
        };

        // Buttons for form actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        {
                            view: 'button',
                            value: _('Limpiar'),
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form data
                            },
                        },
                        {
                            view: 'button',
                            value: _('Guardar'),
                            hotkey: 'enter',
                            type: 'form',
                            minWidth: 200,
                            click: () => {
                                if (this.getRoot().validate()) {
                                    // Validate form before submission
                                    var filterdata = this.getRoot().getValues(); // Get form values
                                    filterdata.Partner = partnerCountry.Partner; // Add partner information
                                    filterdata.Country = partnerCountry.Country; // Add country information
                                    filterdata.Contingency = $$('StateSwith').getValue(); // Get contingency switch value
                                    filterdata.Liquidations = $$('StateSwith2').getValue(); // Get liquidations switch value
                                    filterdata.AutomaticallyActive = $$('StateSwith3').getValue(); // Get automatically active switch value
                                    filterdata.ActiveRegistrationDeposit = $$('StateSwith4').getValue(); // Get active registration deposit switch value
                                    filterdata.AccountVerificationDeposit = $$('StateSwith5').getValue(); // Get account verification deposit switch value
                                    filterdata.ActiveRegistrationWithdraw = $$('StateSwith6').getValue(); // Get active registration withdraw switch value
                                    filterdata.AccountVerificationWithdraw = $$('StateSwith7').getValue(); // Get account verification withdraw switch value
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(devConfig.geturlApi() + 'es/Setting/UpdatePartnerSettings', filterdata, {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message('Error! '); // Show error message on failure
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var data = JSON.parse(text); // Parse response data
                                                webix.message({
                                                    text: _('Informacíon Actualizada'), // Success message
                                                    title: _('¡Exito!'),
                                                    type: 'alert-warning',
                                                });
                                            },
                                        });
                                }
                            },
                        },
                    ],
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            id: 'formSettingsPartner',
            rows: [accordion_section, buttons],
            rules: {
                MinPercentageWagered: function (value) {
                    return value >= 0 && value <= 100; // Validation rule for minimum percentage wagered
                },
                PenaltyWithdrawalBalanceRecharge: function (value) {
                    return value >= 0 && value <= 100; // Validation rule for penalty withdrawal balance recharge
                },
                PenaltyWithdrawalBalanceWithdrawal: function (value) {
                    return value >= 0 && value <= 100; // Validation rule for penalty withdrawal balance withdrawal
                },
                TaxWithdrawBalanceDeposit: function (value) {
                    return value >= 0 && value <= 100; // Validation rule for tax withdrawal balance deposit
                },
                TaxWithdrawBalanceAward: function (value) {
                    return value >= 0 && value <= 100; // Validation rule for tax withdrawal balance award
                },
                TaxWithdrawBalanceAwardFrom: function (value) {
                    return value >= 0 && value <= 100; // Validation rule for tax withdrawal balance award from
                },
                TaxRegulatorFrom: function (value) {
                    return value >= 0 && value <= 100; // Validation rule for tax regulator from
                },
                TaxRegulator: function (value) {
                    return value >= 0 && value <= 100; // Validation rule for tax regulator
                },
                TaxWithdrawBalanceDepositFrom: function (value) {
                    return value >= 0 && value <= 100; // Validation rule for tax withdrawal balance deposit from
                },
                TaxBetPayPrize: function (value) {
                    return value >= 0 && value <= 100; // Validation rule for tax bet pay prize
                },
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        $$('formSettingsPartner').hide(); // Hide the form initially
        this.on(this.app, 'partnerSettings:filter', (filterdata) => {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(devConfig.geturlApi() + 'es/Setting/GetPartnerSettings', filterdata, {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Show error message on failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var data = JSON.parse(text); // Parse response data
                        console.log(data); // Log data for debugging
                        form.setValues(data.data); // Set form values from response data
                        // Set switch values based on response data
                        if (data.data.Contingency == 'A') {
                            $$('StateSwith').setValue(1);
                        } else {
                            $$('StateSwith').setValue(0);
                        }
                        if (data.data.Liquidations == 'A') {
                            $$('StateSwith2').setValue(1);
                        } else {
                            $$('StateSwith2').setValue(0);
                        }
                        if (data.data.AutomaticallyActive == 'A') {
                            $$('StateSwith3').setValue(1);
                        } else {
                            $$('StateSwith3').setValue(0);
                        }
                        if (data.data.ActiveRegistrationDeposit == 'A') {
                            $$('StateSwith4').setValue(1);
                        } else {
                            $$('StateSwith4').setValue(0);
                        }
                        if (data.data.AccountVerificationDeposit == 'A') {
                            $$('StateSwith5').setValue(1);
                        } else {
                            $$('StateSwith5').setValue(0);
                        }
                        if (data.data.ActiveRegistrationWithdraw == 'A') {
                            $$('StateSwith6').setValue(1);
                        } else {
                            $$('StateSwith6').setValue(0);
                        }
                        if (data.data.AccountVerificationWithdraw == 'A') {
                            $$('StateSwith7').setValue(1);
                        } else {
                            $$('StateSwith7').setValue(0);
                        }
                    },
                });
        });
    }
}

// FILE DOCUMENTED
